import * as echarts from 'echarts'
import 'echarts-gl'

export default{
    install(Vue){
        Vue.prototype.$echarts = echarts
    },
    $echarts:echarts
 }